<template>
    <div class="sustainable-component pot-analysis">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-analysis</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <p>
                        Kostnad för löneökningen: <strong><span v-decimal-text.max2="salaryIncrease"></span> kr</strong>
                    </p>
                    <p>
                        Kostnad för löneökningen i procent: <strong><span v-decimal-text.max2="salaryIncreasePercentage"></span> %</strong>
                    </p>
                    <p>
                        Kvar att fördela: <strong><span v-decimal-text.max2="salaryLeftToDistribute"></span> kr</strong>
                    </p>
                    <a href="javascript:void(0)" @click="print">Visa löneanalys i Excel</a>
                    <br />
                    <a href="javascript:void(0)" @click="displayDiagrams">Visa diagram</a>
                </div>
            </div>
            <div class="row mt-5" v-if="this.showDiagrams == true">
                <div class="col-12">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="jobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row px-3" v-if="this.showDiagrams == true">
                <div class="col-12 text-center" style="background-color:white;">
                    <img v-bind:src="getSexDistribution()" style="width:80%;" />
                </div>
            </div>
            <div class="row px-3" v-if="this.showDiagrams == true">
                <div class="col-12 text-center" style="background-color:white;">
                    <img v-bind:src="getAverageSalaryUrl()" style="width:80%;" />
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'

    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'pot-analysis',
        components: {
            CommonSpinner,
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            getAsSwedishNumberString(number) {
                return number.toString().replace(".", ",");
            },
            async loadPotDistribution() {
                try {
                    var result = await WageService.getPotDistribution()
                    this.salaryIncrease = this.getAsSwedishNumberString(result.SalaryIncrease);
                    this.salaryIncreasePercentage = this.getAsSwedishNumberString(result.SalaryIncreasePercentage);
                    this.salaryLeftToDistribute = this.getAsSwedishNumberString(result.SalaryLeftToDistribute);

                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
            },
            async print() {
                location.href = '/PotDistribution/ExportToExcel';
            },
            getSexDistribution() {
                if (this.selectedPosition != null) {
                    return "/PotDistribution/GetSexDistribution?jobPositionId=" + this.selectedPosition;
                }
                return "/PotDistribution/GetSexDistribution";
            },
            getAverageSalaryUrl() {
                return "/PotDistribution/GetAverageSalary";
            },
            displayDiagrams() {
                this.showDiagrams = true;
            },
            async loadPositions() {
                try {
                    this.jobPositions = [{ Name: 'Ingen vald', JobPositionId: null }, ...await WageService.getReferencePositions()];
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                salaryIncrease: "0",
                salaryIncreasePercentage: "0",
                salaryLeftToDistribute: "0",
                showDiagrams: false,
                selectedPosition: null,
                jobPositions: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            
        },
        mounted() {
            this.loadPotDistribution()
            this.loadPositions();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
